/**
 * @format
 * @flow strict-local
 */
// DEPENDENCIES

import styled from "styled-components";

import {
	rowWrapper
 } from "../../styled/styled-extends";
import {
	setFont
} from "../../styled/styled-mixins";
import {
	colors,
	fonts
} from "../../styled/styled-variables";

// EXPORT

export const ContentWrapper = styled.div`
	align-items: stretch;
	border-style: solid;
	border-width: 1px;
	border-radius: 8px;
	height: 48px;
	outline: 4px solid transparent;
	text-align: left;
	transition: 
		background-color 200ms ease, 
		border-color 200ms ease, 
		color 200ms ease,
		outline-color 200ms ease
	;
	width: 100%;
	will-change: 
		background-color, 
		border-color, 
		color,
		outline-color
	;
	${rowWrapper}

	> * {
		border-color: inherit;
		padding: 12px 16px;
	}

	input {
		appearance: none;
		background-color: transparent;
		border: 0;
		box-sizing: border-box;
		color: inherit;
		font: inherit;
		height: 100%;
		margin: 0;
		outline: none;
		text-align: inherit;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 100%;
	}
`;
/*
${(props) => {
		const {
			input
		} = props.theme;

		let backgroundColor = "#FFF";//input.backgroundColor;
		let borderColor = "#EEE";//input.borderColor;
		let color = ""input.color;
		let outlineColor = "transparent";
		let pointerEvents = "auto";

		if(
			props.disabled || 
			props.readOnly
		) {
			backgroundColor = input.disabledBackgroundColor;
			borderColor = input.disabledBorderColor;
			color = input.disabledColor;
			pointerEvents = "none";
		} else {
			if(props.hasError) {
				backgroundColor = input.errorBackgroundColor;
				borderColor = input.errorBorderColor;
				color = input.errorColor;
				
				if(props.hasFocus) {
					outlineColor = input.errorOutlineColor;
				}
			} else if(props.hasFocus) {
				backgroundColor = input.focusBackgroundColor;
				borderColor = input.focusBorderColor;
				color = input.focusColor;
				outlineColor = input.focusOutlineColor;
			}
		}

		return `
			background-color: ${backgroundColor};
			border-color: ${borderColor};
			outline-color: ${outlineColor};
			pointer-events: ${pointerEvents};
			${setFont(
				fonts.inter,//typo.fontFamilies.roboto,
				"16px",
				400,
				1.5,
				color
			)}
			
			input {
				::placeholder {
					color: ${input.placeholderColor};
				}

				:-webkit-autofill {
					border-radius: inherit;
					-webkit-box-shadow: 0 0 0px 1000px ${backgroundColor} inset;
				}
			}
		`;
	}}
*/